import { render, staticRenderFns } from "./OrderReceptionBoxForm.vue?vue&type=template&id=a46d3aae"
import script from "./OrderReceptionBoxForm.vue?vue&type=script&lang=js"
export * from "./OrderReceptionBoxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports